angular.module('app')
    .service('notificationsApi', notificationsApi);

notificationsApi.$inject = [
    '$resource',
    'settings',
];

function notificationsApi(
    $resource,
    settings
) {
    /**
     * Adds extra methods and values. Expects "this" to be bound to an event object
     * @return {this}
     */
    function transform() {
        return this;
    }

    var resource = $resource(settings.apiBase + '/notifications', {
    }, {
        post: {
            method: 'POST',
            responseType: 'json'
        },
    });

    resource.prototype.transform = transform;

    return resource;
}
